import React from "react";
import { Col, Row } from "react-bootstrap";

const Vehicles = ({ data, anotherData }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Year:</strong>
              {data?.year || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Make:</strong>
              {data?.make || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle model:</strong>
              {data?.model || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Mileage:</strong>
              {data?.mileage || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Purchase Lease Date:</strong>
              {data?.purchase_lease_date || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Current Market Value:</strong>
              {data?.cutrrent_market_value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Amount Owned:</strong>
              {data?.amount_owned || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Monthly Payment:</strong>
              {data?.monthly_payment || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Name:</strong>
              {data?.name || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Address:</strong>
              {data?.address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Phone of lender lessor:</strong>
              {data?.phone_of_lender_lessor || "--"}
            </div>
          </Col>
          <Col md={12}>
            <h5 className="mb-4">Another Vehicle Description</h5>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Year:</strong>
              {anotherData?.year || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Make:</strong>
              {anotherData?.make || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle model:</strong>
              {anotherData?.model || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Mileage:</strong>
              {anotherData?.mileage || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Purchase Lease Date:</strong>
              {anotherData?.purchase_lease_date || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Current Market Value:</strong>
              {anotherData?.cutrrent_market_value || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Amount Owned:</strong>
              {anotherData?.amount_owned || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Monthly Payment:</strong>
              {anotherData?.monthly_payment || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Name:</strong>
              {anotherData?.name || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Address:</strong>
              {anotherData?.address || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Phone of lender lessor:</strong>
              {anotherData?.phone_of_lender_lessor || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Vehicles;
